import {
  REQUEST_ROUTES,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  REQUEST_ALL_ROUTES,
  FETCH_ALL_ROUTES_SUCCESS,
  FETCH_ALL_ROUTES_FAILURE,
  REQUEST_STOPS,
  FETCH_STOPS_SUCCESS,
  FETCH_STOPS_FAILURE,
  REQUEST_EDIT_STOPS,
  FETCH_EDIT_STOPS_SUCCESS,
  FETCH_EDIT_STOPS_FAILURE,
  REQUEST_SAVE_EDITS,
  SAVE_EDITS_SUCCESS,
  SAVE_EDITS_FAILURE,
  CLEAR_EDIT_STATUS,
  REQUEST_SALES_ORDERS_BY_DATE,
  FETCH_SALES_ORDERS_BY_DATE_SUCCESS,
  FETCH_SALES_ORDERS_BY_DATE_FAILURE,
  REQUEST_CUSTOMER_ROUTES,
  FETCH_CUSTOMER_ROUTES_SUCCESS,
  FETCH_CUSTOMER_ROUTES_FAILURE,
  REQUEST_UNASSIGNED_ORDERS,
  FETCH_UNASSIGNED_ORDERS_SUCCESS,
  FETCH_UNASSIGNED_ORDERS_FAILURE,
  REQUEST_ASSIGN_ORDER_ROUTE,
  ASSIGN_ORDER_ROUTE_SUCCESS,
  ASSIGN_ORDER_ROUTE_FAILURE,
  REQUEST_SAVE_ROUTE_EDITS,
  SAVE_ROUTE_EDIT_SUCCESS,
  SAVE_ROUTE_EDIT_FAILURE,
  REQUEST_CONVERT_TO_INVOICE,
  CONVERT_TO_INVOICE_SUCCESS,
  CONVERT_TO_INVOICE_FAILURE,
  CLEAR_CONVERT_TO_INVOICE,
  CONVERT_TO_INVOICE_RESET,
  SAVE_EDITED_STOPS,
  SAVE_EDITED_STOPS_SUCCESS,
  SAVE_EDITED_STOPS_FAILURE,
  REQUEST_SAVE_NEW_ROUTES,
  SAVE_NEW_ROUTES_SUCCESS,
  SAVE_NEW_ROUTES_FAILURE,
  FETCH_ROUTES_PRINTER_SUCESS,
  SAVE_ROUTES_PRINTER_SUCESS,
  FETCH_AUTO_ROUTES_SUCCESS,
  SET_AUTO_ROUTING_BUTTONS_LOADING,
  START_FETCHING_AUTO_ROUTES,
  SELECT_DRIVER,
  RESET_CURRENT_DRIVER,
  CREATE_DRIVER_SUCCESS,
  CREATE_DRIVER_FAILURE,
  EDIT_DRIVER_SUCCESS,
  EDIT_DRIVER_FAILURE,
  RESET_CREATE_DRIVER,
  RESET_EDIT_DRIVER,
} from '../actions/type';

const INITIAL_STATE = {
  autoRoutes: [],
  routes: [],
  routesIsLoading: false,
  routesError: null,
  allroutes: [],
  allroutesIsLoading: false,
  allroutesError: null,
  stops: [],
  stopsIsLoading: false,
  stopsError: null,
  editStops: [],
  editStopsIsLoading: false,
  editStopsError: null,
  savingStopEdits: false,
  saveStopEditsSuccessful: null,
  saveStopEditsFailure: null,
  savingRouteEdits: false,
  saveRouteEditsSuccessful: null,
  saveRouteEditsFailure: null,
  saveRouteEditsError: null,
  salesOrders: [],
  salesOrdersIsLoading: false,
  salesOrdersError: null,
  customerRoutes: [],
  customerRoutesIsLoading: false,
  customerRoutesError: null,
  unassignedOrders: [],
  unassignedOrdersIsLoading: false,
  unassignedOrdersError: null,
  assigningOrderRoute: false,
  assignOrderRouteSuccess: null,
  assignOrderRouteFailure: null,
  convertingToInvoice: false,
  convertToInvoiceSuccess: null,
  convertToInvoiceFailure: null,
  convertToInvoiceError: null,
  refreshConvertingToInvoice: false,
  savingEditedStops: false,
  saveEditedStopsSuccess: null,
  saveEditedStopsFailure: null,
  savingNewRoute: false,
  saveNewRouteSuccess: null,
  saveNewRouteError: null,
  routesPrinters: [],
  savePrinterSuccess: false,
  buttonLoadingVisible: false,
  pdfFile: null,
  allRoutesLEES: [],
  currentDriver: null,
  isCreating: false,
  createError: null,
  created: false,
  isEditing: false,
  editError: null,
  edited: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
      case 'ALL_ROUTES':
        return { ...state, allRoutesLEES: action.payload };
      case START_FETCHING_AUTO_ROUTES:
          return { ...state, autoRoutes: [], stops: []};
      case SAVE_ROUTES_PRINTER_SUCESS:
          return { ...state, savePrinterSuccess: action.payload };
      case SET_AUTO_ROUTING_BUTTONS_LOADING:
          return { ...state, buttonLoadingVisible: action.payload };
      case FETCH_AUTO_ROUTES_SUCCESS:
          return { ...state, autoRoutes: action.payload.data, routesIsLoading: false };
      case FETCH_ROUTES_PRINTER_SUCESS:
          return { ...state, routesPrinters: action.payload };
      case REQUEST_ROUTES:
          return { ...state, routesError: null, routesIsLoading: true };
      case FETCH_ROUTES_SUCCESS:
          return { ...state, routes: action.payload.data, routesIsLoading: false };
      case FETCH_ROUTES_FAILURE:
          const routesError = action.payload.data || { message : action.payload.message };
          return { ...state, routesError: routesError, routesIsLoading: false };
      case REQUEST_ALL_ROUTES:
          return { ...state, allroutesError: null, allroutesIsLoading: true };
      case FETCH_ALL_ROUTES_SUCCESS:
          return { ...state, allroutes: action.payload.data, allroutesIsLoading: false };
      case FETCH_ALL_ROUTES_FAILURE:
          const allroutesError = action.payload.data || { message : action.payload.message };
          return { ...state, allroutesError: allroutesError, allroutesIsLoading: false };
      case REQUEST_STOPS:
          return { ...state, stopsIsLoading: true, stopsError: false };
      case FETCH_STOPS_SUCCESS:
          return { ...state, stops: action.payload.data, stopsIsLoading: false };
      case FETCH_STOPS_FAILURE:
          const stopsError = action.payload.data || { message: action.payload.message };
          return { ...state, stopsError: stopsError, stopsIsLoading: false };
      case REQUEST_EDIT_STOPS:
          return { ...state, editStopsIsLoading: true, editStopsError: null };
      case FETCH_EDIT_STOPS_SUCCESS:
          return { ...state, editStops: action.payload.data, editStopsIsLoading: false };
      case FETCH_EDIT_STOPS_FAILURE:
          const editStopsError = action.payload.data || { message: action.payload.message };
          return { ...state, editStopsError: editStopsError, editStopsIsLoading: false };
      case REQUEST_SAVE_EDITS:
          return { ...state, savingStopEdits: true, saveStopEditsFailure: null , saveStopEditsSuccessful: null };
      case SAVE_EDITS_SUCCESS:
          return { ...state, savingStopEdits: false, saveStopEditsSuccessful: true};
      case SAVE_EDITS_FAILURE:
          const saveStopEditsFailure = action.payload.data || { message: action.payload.message };
          return { ...state, savingStopEdits: false, saveStopEditsFailure: saveStopEditsFailure };
      case CLEAR_EDIT_STATUS:
          return { ...state, saveStopEditsFailure: null, saveStopEditsSuccessful: null };
      case REQUEST_SALES_ORDERS_BY_DATE:
          return { ...state, salesOrdersIsLoading: true, salesOrdersError: null };
      case FETCH_SALES_ORDERS_BY_DATE_SUCCESS:
          return { ...state, salesOrders: action.payload.data, salesOrdersIsLoading: false };
      case FETCH_SALES_ORDERS_BY_DATE_FAILURE:
          const salesOrdersError = action.payload.data || { message: action.payload.message };
          return { ...state, salesOrdersError: salesOrdersError, salesOrdersIsLoading: false };
      case REQUEST_CUSTOMER_ROUTES:
          return { ...state, customerRoutesIsLoading: true, customerRoutesError: null };
      case FETCH_CUSTOMER_ROUTES_SUCCESS:
          return { ...state, customerRoutes: action.payload.data, customerRoutesIsLoading: false };
      case FETCH_CUSTOMER_ROUTES_FAILURE:
          const customerRoutesError = action.payload.data || { message: action.payload.message };
          return { ...state, customerRoutesError: customerRoutesError, customerRoutesIsLoading: false };
      case REQUEST_UNASSIGNED_ORDERS:
          return { ...state, unassignedOrdersIsLoading: true, unassignedOrdersError: null };
      case FETCH_UNASSIGNED_ORDERS_SUCCESS:
          return { ...state, unassignedOrders: action.payload.data, unassignedOrdersIsLoading: false };
      case FETCH_UNASSIGNED_ORDERS_FAILURE:
          const unassignedOrdersError = action.payload.data || { message: action.payload.message };
          return { ...state, unassignedOrdersError: unassignedOrdersError, unassignedOrdersIsLoading: false };
      case REQUEST_ASSIGN_ORDER_ROUTE:
          return { ...state, assigningOrderRoute: true, assignOrderRouteSuccess: null, assignOrderRouteFailure: null };
      case ASSIGN_ORDER_ROUTE_SUCCESS:
          return { ...state, assigningOrderRoute: false, assignOrderRouteSuccess: true };
      case ASSIGN_ORDER_ROUTE_FAILURE:
          return { ...state, assigningOrderRoute: false, assignOrderRouteFailure: true };
      case REQUEST_SAVE_ROUTE_EDITS:
          return { ...state, savingRouteEdits: true, saveRouteEditsFailure: null, saveRouteEditsSuccessful: null };
      case SAVE_ROUTE_EDIT_SUCCESS:
          return { ...state, savingRouteEdits: false, saveRouteEditsSuccessful: true };
      case SAVE_ROUTE_EDIT_FAILURE:
          const saveRouteEditsError = action.payload.data || { message: action.payload.message };
          alert(JSON.stringify(saveRouteEditsError));
          return { ...state, savingRouteEdits: false, saveRouteEditsFailure: true, saveRouteEditsError: saveRouteEditsError }
      case REQUEST_CONVERT_TO_INVOICE:
          return { ...state, convertingToInvoice: true, convertToInvoiceSuccess: null, convertToInvoiceFailure: null, refreshConvertingToInvoice: false, convertToInvoiceError: null };
      case CONVERT_TO_INVOICE_SUCCESS:
          return { ...state, convertingToInvoice: false, convertToInvoiceSuccess: action.payload.data, refreshConvertingToInvoice: false, convertToInvoiceError: null };
      case CONVERT_TO_INVOICE_FAILURE:
          const convertToInvoiceError = action.payload.data || { message: action.payload.message };
          return { ...state, convertingToInvoice: false, convertToInvoiceFailure: true, refreshConvertingToInvoice: false, convertToInvoiceError };
      case CLEAR_CONVERT_TO_INVOICE:
          return { ...state, convertingToInvoice: false, convertToInvoiceFailure: null, convertToInvoiceSuccess: null, refreshConvertingToInvoice: true}
      case CONVERT_TO_INVOICE_RESET:
          return { ...state, refreshConvertingToInvoice: true };
      case SAVE_EDITED_STOPS:
          return { ...state, savingEditedStops: true, saveEditedStopsSuccess: false, saveEditedStopsFailure: false };
      case SAVE_EDITED_STOPS_SUCCESS:
          return { ...state, savingEditedStops: false, saveEditedStopsSuccess: true, saveEditedStopsFailure: false };
      case SAVE_EDITED_STOPS_FAILURE:
          const saveEditedStopsError = action.payload.data || { message: action.payload.message };
          alert(JSON.stringify(saveEditedStopsError));
          return { ...state, savingEditedStops: false, saveEditedStopsSuccess: true, saveEditedStopsFailure: true };
      case  REQUEST_SAVE_NEW_ROUTES:
          return {
            ...state,
            savingNewRoute: true,
            saveNewRouteSuccess: false,
            saveNewRouteError: null,
          };
      case  SAVE_NEW_ROUTES_SUCCESS:
          return {
            ...state,
            savingNewRoute: false,
            saveNewRouteSuccess: true,
            saveNewRouteError: null,
          };
      case  SAVE_NEW_ROUTES_FAILURE: {
          const saveNewRouteError = action.payload.data || { message: action.payload.message };
          alert(JSON.stringify(saveNewRouteError));
          return {
            ...state,
            savingNewRoute: false,
            saveNewRouteSuccess: false,
            saveNewRouteError,
          };
        }
      case 'AUTO_ROUTING/routePickingList':
        return {
            ...state,
            pdfFile: action.payload,
          };
      case SELECT_DRIVER:
          return { ...state, currentDriver: action.payload };
      case RESET_CURRENT_DRIVER:
          return { ...state, currentDriver: null };
    
      case CREATE_DRIVER_SUCCESS:
          return { ...state, isCreating: false, createError: null, created: true };
      case CREATE_DRIVER_FAILURE:
          const createError = action.payload.data || { message: action.payload.message };
          return { ...state, isCreating: false, createError, created: false };
      case RESET_CREATE_DRIVER:
        return { ...state, isCreating: false, createError: null, created: false };
            
      case EDIT_DRIVER_SUCCESS:
          return { ...state, isEditing: false, editError: null, edited: true };
      case EDIT_DRIVER_FAILURE:
          const editError = action.payload.data || { message: action.payload.message };
          return { ...state, isEditing: false, editError, edited: false };
      case RESET_EDIT_DRIVER:
          return { ...state, isEditing: false, editError: null, edited: false };
      default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/dispatch_reducer.jsx